export default __webpack_public_path__ + "assets/icons/whole-tracking.417c59a5.svg";